module.exports = __webpack_public_path__ + "static/media/paper_facory_getty_mobile.726f4402.jpg";